module.exports = "<div class=\"{{baMultiCheckboxClass}} container-content\">\r\n  <ba-checkbox *ngFor=\"let item of state\"\r\n               [(ngModel)]=\"item[propertiesMapping.model]\"\r\n               [baCheckboxClass]=\"getProp(item, 'baCheckboxClass')\"\r\n               [label]=\"getProp(item, 'label')\"\r\n               [disabled]=\"getProp(item, 'disabled')\"\r\n               [value]=\"getProp(item, 'value')\"\r\n               id=\"{{getProp(item, 'id')}}\">\r\n  </ba-checkbox>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/components/baMultiCheckbox/baMultiCheckbox.html
// module id = 1586
// module chunks = 18